/**
 * Точка входа auth-флоу.
 *
 * Всё на Alpine (Этап 3.17b/c):
 *   wizard.js   — registrationWizard (регистрация: 4 шага)
 *   dialogs.js  — authDialogs (login / forgot / reset / reset-success / token-expired)
 *   widgets.js  — personTitle, password toggle, search toggle, pinup toggle
 *
 * Публичные события (любое место кода может их отправить):
 *   register:open
 *   login:open
 *   password:forgot
 *   password:reset (detail: { token, email })
 *   password:reset-success
 *   password:token-expired
 *
 * Legacy data-form-id="..." остаётся частично для старых ссылок (рендерятся в Blade-страницах)
 * и просто мапится на соответствующие события.
 */

import { initAuthWidgets } from './widgets.js';
import './wizard.js';  // Alpine.data('registrationWizard')
import './dialogs.js'; // Alpine.data('authDialogs') — login/forgot/reset/success/token-expired

// Соответствие старых data-form-id → CustomEvent
const DATA_FORM_ID_TO_EVENT = {
    '#form_register_step1': 'register:open',
    '#form_login': 'login:open',
    '#form_forgot_password': 'password:forgot',
};

function init() {
    // Ссылки с data-form-id → события открытия Alpine-компонентов
    document.addEventListener('click', e => {
        const trigger = e.target.closest('[data-form-id]');
        if (!trigger) return;

        const id = trigger.getAttribute('data-form-id');
        const eventName = DATA_FORM_ID_TO_EVENT[id];
        if (eventName) {
            e.preventDefault();
            document.dispatchEvent(new CustomEvent(eventName));
        }
        // Для неизвестных data-form-id ничего не делаем — старый FancyBox-вызов удалён
    });

    initAuthWidgets();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
